/**
 * 模組頁面代碼 : 1310-UI-01
 * 頁面說明 : 大樓資料清單列表頁面
 * @module modules/building/components/BukildingPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';

import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class BuildingPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchBuildingId: '',
        };
        this.setSearchBuildingId = this.setSearchBuildingId.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareBuildingTable = this.prepareBuildingTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    setSearchBuildingId(searchBuildingId) {
        this.setState({ searchBuildingId });
    }

    prepareBuildingTable = () => {
        const { buildingList } = this.props;
        // 定義資料內容
        const dataSet = buildingList.map((building) => {
            const controlRadius = building.flgUnlimit === 1 ? '不限制' : building.controlRadius;
            return [
                building.buildingName,
                building.elevatorNumbers,
                building.aboveFloors,
                building.underFloors,
                building.latitude,
                building.longitude,
                controlRadius,
                building.updateTime,
                building.flgStatus,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-building-' + meta.row;
                    return `<div class="form-check">
                                <input class="form-check-input item-cks-building" type="checkbox" value="" id="${checkboxId}" name="cks" />
                                <label class="form-check-label" for="${checkboxId}"></label>
                            </div>`;
                },
                width: '5%',
            },
            { title: '大樓名稱', data: 0 },
            { title: '電梯數量', className: 'dt-center', data: 1 },
            { title: '地面樓層數', className: 'dt-center', data: 2 },
            { title: '地下樓層數', className: 'dt-center', data: 3 },
            { title: '緯度', className: 'dt-center', data: 4 },
            { title: '經度', className: 'dt-center', data: 5 },
            { title: '控制半徑 (m)', className: 'dt-center', data: 6 },
            { title: '修改時間', className: 'dt-head-center', data: 7, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                orderable: false,
                order: null,
                title: '啟用',
                data: 8,
                className: 'dt-center',
                render: (data, type, row, meta) => {
                    let enableId = 'eab-building-' + meta.row;
                    let isChecked = data === 'A' ? 'checked' : '';
                    let enableButton = this.checkPermission(ModuleEnums.BUILDING, AccessModeEnums.DELETE) ? '' : 'disabled';
                    return `<div class="form-check form-switch">
                               <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                               <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
                },
            },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let ctlId = 'ctl-device-' + meta.row
                    let editId = 'edit-building-' + meta.row
                    let ctrlDeviceButton = this.checkPermission(ModuleEnums.DEVICE, AccessModeEnums.READ) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${ctlId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-settings-02"></use>
                            </svg>
                            梯控設定
                        </button>` : '';
                    let editButton = this.checkPermission(ModuleEnums.BUILDING, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            修改
                        </button>` : '';
                    return `<div class="btn-group" role="group" aria-label="">
                                ${ctrlDeviceButton}
                                ${editButton}
                            </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 1,
            dir: 'asc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__buildingList')) {
            $('#datatable__buildingList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__buildingList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    componentDidMount() {
        // 確認是否有大樓資料讀取權限
        this.checkPermission(ModuleEnums.BUILDING, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needBuildingLoad, setNeedBuildingLoad, buildingList } = this.props;
        if (needBuildingLoad && 
            needBuildingLoad !== prevProps.needBuildingLoad) {
            if (buildingList.length > 0) {
                this.prepareBuildingTable();
            }
            setNeedBuildingLoad(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const buildingId = parseInt(searchForm.get('searchBuildingSelection')? searchForm.get('searchBuildingSelection') : 0);
        this.props.setSearchBuilding(buildingId);
        this.props.fetchBuildingList(buildingId).then(() => {
            // Get data and redraw datatable
            this.prepareBuildingTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                if (button && button.id.startsWith('ctl-device-')) {
                    this.props.onControlDeviceList(parseInt(button.id.split('-')[2]));
                }
                if (button && button.id.startsWith('edit-building-')) {
                    this.props.onEditBuilding(parseInt(button.id.split('-')[2]));
                }
            });
            this.tableRef.current.addEventListener('change', (event) => {
                const checkbox = event.target.closest('input[type="checkbox"]');
                if (checkbox && checkbox.id.startsWith('eab-building-')) {
                    const index = parseInt(checkbox.id.split('-')[2]);
                    const mode = checkbox.checked ? AlertModalModeEnums.ENABLE : AlertModalModeEnums.DISABLE;
                    const updateBuilding = this.props.buildingList[index];
                    if (updateBuilding) {
                        let message = '';
                        if (mode === AlertModalModeEnums.ENABLE) {
                            message = `啟用 [ ${updateBuilding.buildingName} ] 的資料`;
                        } else {
                            message = `停用 [ ${updateBuilding.buildingName} ] 的資料`;
                        }
                        this.props.onEditBuildingStatus(mode, message, updateBuilding.buildingId);
                    } else {
                        console.log('No building found at index:', index);
                    }
                }
            });
        }
    }

    onBatchHandle(alertMode = AlertModalModeEnums.ENABLE) {
        const buildingIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-building');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const buildingId = this.props.buildingList[parseInt(checkbox.id.split('-')[2])].buildingId;
                buildingIds.push(buildingId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (buildingIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(alertMode, buildingIds);      
    }

    render() {
        const { buildingSelection, onNewBuilding } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="系統設定" pageName="大樓資料" />
                <h4>大樓資料</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchBuilding" className="form-label">大樓名稱*</label>
                            <select className="form-select form-select-sm" id="searchBuildingSelection" name="searchBuildingSelection" value={this.state.searchBuildingId} onChange={e => this.setSearchBuildingId(e.target.value)} required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {buildingSelection.map((building, index) => (
                                    <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" aria-label="搜尋">
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                            {this.checkPermission(ModuleEnums.BUILDING, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="啟用" id="btnBatchEnable" onClick={() => this.onBatchHandle(AlertModalModeEnums.ENABLE)}>啟用</button>
                            )}
                            {this.checkPermission(ModuleEnums.BUILDING, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="停用" id="btnBatchDisable" onClick={() => this.onBatchHandle(AlertModalModeEnums.DISABLE)}>停用</button>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.BUILDING, AccessModeEnums.CREATE) && (
                        <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalBuildingBtnNew" onClick={onNewBuilding}>
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-plus"></use>
                            </svg>
                            新增
                        </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__buildingList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

BuildingPage.propTypes = {
};

BuildingPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildingPage);